"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pluralize = void 0;
exports.pluralize = (value, count = 1, inclusive = false) => {
    let output = value;
    if (count !== 1) {
        output += "s";
    }
    return inclusive ? `${count} ${output}` : output;
};
//# sourceMappingURL=pluralize.js.map